import { IAuthContext } from '../../common/hooks/workosAuthProvider';
import { IAuthenticationProvider } from '../../common/types';
import { StreamMakeSuggestionBasedOnWorkItemXAccessTokenTypeEnum } from '../../common/clients/ogg';

export default class WorkOsAuthenticationProvider implements IAuthenticationProvider {
  constructor(private readonly authContext: IAuthContext) {}

  accessTokenType: StreamMakeSuggestionBasedOnWorkItemXAccessTokenTypeEnum =
    StreamMakeSuggestionBasedOnWorkItemXAccessTokenTypeEnum.WorkOS;

  getBearerToken(): Promise<string> {
    return this.authContext.getAccessToken();
  }

  async getUserEmail(): Promise<string> {
    return this.authContext.user.Email;
  }
}
